import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import LinearProgress from "@mui/material/LinearProgress";
import { ActionContext } from "context/ActionContext";
import { IntInput, TextInput } from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";
import {  targetedenergyList } from "variables/lists/action";

const RTEquipments = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Source d'énergie",
      selector: (row) => row.energysource,
      sortable: true,
      cell: (row) => row.energysource ?
      <div>
        {targetedenergyList.find((x) => x.id == row.energysource).name}
      </div> : <></>
    },
    {
      name: "Usage (Catégorie Système)",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Part de conso.",
      selector: (row) => row.consumptionpart,
      sortable: true,
      cell: (row) => (
        <div>
          {row.consumptionpart ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 3}).format(row.consumptionpart) : ''}
        </div>
      ),

    },
    {
      name: "Part de conso. modifiée",
      selector: (row) => row.consumptionpartNew,
      sortable: true,
      cell: (row) => (
        <div>
          {row.consumptionpartNew ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 3}).format(row.consumptionpartNew) : ''}
        </div>
      ),
    },
  ];

  const handleSelectedChange = ({ selectedRows }) => {
    if (actionplanupdate) {
      selectedRows.map((equipment) => (equipment.isSelected = true));
      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters?.impact,
            equipments: selectedRows,
          },
        },
      }));
    }
  };

  const contextMessage = {
    singular: "équipement sélectionné",
    plural: "équipements sélectionnés",
    message: "",
  };

  const selectableRowDisabled = (row) => {
    if (!actionplanupdate) {
      return row;
    }
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des equipements"
        noDataComponent="Aucun équipement retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        //subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        selectableRows
        onSelectedRowsChange={handleSelectedChange}
        selectableRowSelected={rowSelectCritera}
        selectableRowsHighlight
        selectableRowDisabled={selectableRowDisabled}
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTEquipments;
